import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateNotificationStatus extends Enum {
  static TODO = {
    key: 'todo',
    get value() {
      return Lang.t('estate.to-do');
    },
    get displayValue() {
      return Lang.t('estate.notifications-to-do');
    },
    color: '#7E84A3'
  };

  static SENT = {
    key: 'sent',
    get value() {
      return Lang.t('esign.sent');
    },
    get displayValue() {
      return Lang.t('estate.notifications-partially-completed');
    },
    color: '#EE964B'
  };

  static COMPLETE = {
    key: 'complete',
    get value() {
      return Lang.t('accounting.completed');
    },
    get displayValue() {
      return Lang.t('estate.notifications-completed');
    },
    color: '#60C49D'
  };
}
